import React from "react"
import Field from "./field"
import Select from "./select"
import ErrorMessage from "./error-message"

export const Input = () => { }

Input.Field = ( props ) => <Field { ...props } />
Input.Select = ( props ) => <Select { ...props } />
Input.ErrorMessage = ( props ) => <ErrorMessage { ...props } />

export default Input